// Estado de UI da sidebar do Minha Conta V2. Cada tela do modal remonta o
// UserV2Shell (o Modal troca o <component :is> com :key por tela), então o
// `aside` da navegação perde scroll e expansão a cada clique. Guardar aqui
// (via useState, mesmo padrão de useUserV2Modal.ts — sem isso um ref de
// módulo seria compartilhado entre requests diferentes no SSR) preserva a
// posição de scroll e os grupos abertos entre as trocas de tela — a
// navegação não "pula".
export default function useUserV2SidebarUi() {
  const expandedMenus = useState<Set<string>>(
    'user-v2-sidebar-expanded-menus',
    () => new Set(),
  );

  const scrollTop = useState<number>('user-v2-sidebar-scroll-top', () => 0);

  return { expandedMenus, scrollTop };
}
